import { useEffect, useState } from "react";

const cache = new Map();

/** Real next lesson (same subject + stage, canonical order) from /api/lessons/:code/next — never a generic hub. */
export function useNextLesson(code) {
  const [data, setData] = useState(() => cache.get(code) || null);
  useEffect(() => {
    if (!code) return undefined;
    if (cache.has(code)) { setData(cache.get(code)); return undefined; }
    let off = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/lessons/${encodeURIComponent(code)}/next`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j) cache.set(code, j); if (!off) setData(j); })
      .catch(() => {});
    return () => { off = true; };
  }, [code]);
  return data; // { next: {code,title,route,subject,tier}|null, fallback, stage_complete } | null while loading
}
